import { PAGE_HOME_INCLUSIONE, PAGE_HOME_URL } from 'types/url';

export const breadcrumbPath = [
  {
    slash: 'Home',
    url: PAGE_HOME_URL,
  },
  {
    slash: 'WeMi inclusione',
    url: PAGE_HOME_INCLUSIONE,
  },
  {
    slash: 'GUIDA PER I NUOVI ARRIVATI',
    url: '',
  },
];

export const title = 'WeMi - Inclusione - Guida per i nuovi arrivati';
export const description = 'Descrizione servizio Guida per i nuovi arrivati';
export const keywords = 'welfare, milano, servizi, servizio, WeMi guida, servizio Guida per i nuovi arrivati, informazioni Guida per i nuovi arrivati';
